import Label from '../../../../ui/label'
import { Checked } from '../../../../../assets/icon/svg'
import { useDispatch, useSelector } from 'react-redux';
import { selectIsProposalTypeComplete } from '../../../../../helper/proposal/proposal-is-complete-form-helper';
import { resetAmountOfLoans } from '../../../../../features/gms-proposal-forms/amount-of-loans/amount-loans.slice';
import { resetUniformCoverage } from '../../../../../features/gms-proposal-forms/coverage/uniform-coverage/coverage-type-uniform-coverage.slice';
import { resetLevelRanking, resetLevelRankingType } from '../../../../../features/gms-proposal-forms/coverage/level-ranking/coverage-type-level-ranking.slice';
import { resetSalaryRank, resetSalaryRankType } from '../../../../../features/gms-proposal-forms/coverage/salary-rank/coverage-type-by-salary-rank.slice';
import { resetRiders, resetSelectedRiders } from '../../../../../features/gms-proposal-forms/attachable-rider/attachable-riders.slice';
import ErrorFetch from '../../../../ui/error-fetch-category';
import LoadingCategory from '../../../../ui/loading-category';
import { useQueries } from '../../../../../hooks/services/queries/use-queries';
import { resetCoverageType, setSelectedBasicPlansBox, setSelectedProductTypeBox, setSelectedPrototypeTypeBox } from '../../../../../features/gms-proposal-forms/types-proposal-product-basic-plan/types-proposal-product-basic-plan-slice';
import { resetBorrowerAge } from '../../../../../features/gms-proposal-forms/age-bracket-and-benefit-amount/age-bracket-and-benefit-amount.slice';
import { resetLoanMaturityType, setNotesContent, setSelectedPaymentTermBox } from '../../../../../features/gms-proposal-forms/payment_term-loan_maturity-commission_services-notes-files/payment_term-loan_maturity-commission_services-notes-files.slice';
import { SubTypeOption } from '../../../../../api/gms/group-category/group-category-api-state';
import { useProposalTypeData } from '../../../../../hooks/proposal/use-proposal-type-data';
import { useFilesActions } from '../../../../../hooks/actions/use-files-actions';
import LoadingViewFile from '../../../../ui/loading-view-file';

export default function ClientInputPrototype() {
    const {
        prototypeListData,
        isLoadingPrototypeListData,
        isErrorPrototypeListData,
        errorMessagePrototypeListData,
    } = useQueries();
    const { handleViewPrototypeTemplate, isLoadingViewPrototypeTemplate} = useFilesActions()

    const { prototype } = useProposalTypeData();
    const dispatch = useDispatch();
    const isProposalTypeComplete = useSelector(selectIsProposalTypeComplete);

    const handleChangePrototypeType = (option: SubTypeOption) => {
        dispatch(setSelectedPrototypeTypeBox(option));
        dispatch(setSelectedProductTypeBox(null));
        dispatch(setSelectedBasicPlansBox(null));

        dispatch(resetAmountOfLoans());
        dispatch(resetCoverageType());
        dispatch(resetLevelRanking());
        dispatch(resetUniformCoverage());
        dispatch(resetSalaryRank());
        dispatch(resetSelectedRiders());

        dispatch(setSelectedPaymentTermBox(null));
        dispatch(resetLoanMaturityType());
        dispatch(resetBorrowerAge());
        dispatch(setNotesContent(''));
        dispatch(resetRiders());

        dispatch(resetSalaryRankType());
        dispatch(resetLevelRankingType());
    };

    return (
        <div className="space-y-2">
            <Label
                label="Prototype "
                fontWeight="font-semibold text-gray-800"
                fontSize="text-xs"
                requiredText=" *"
                isRequired={true}
            />

            <div className={`grid gap-2 ${isLoadingPrototypeListData ? 'grid-cols-1' : 'grid-cols-1'}`}>
                {isLoadingPrototypeListData ? (
                    <LoadingCategory />
                ) : isErrorPrototypeListData ? (
                    <ErrorFetch errorMessage={errorMessagePrototypeListData} />
                ) : (
                    prototypeListData?.map((option) => {
                        const isSelected = prototype?.id === option.id;

                        return (
                            <div
                                key={option.id}
                                className={`flex items-center gap-2 rounded border px-3 py-2 transition-all duration-200 ${
                                    !isProposalTypeComplete
                                        ? 'cursor-not-allowed border-gray-200 bg-gray-100 opacity-50'
                                        : isSelected
                                            ? 'border-[#186cb2]/30 bg-[#186cb2]/10 shadow-sm'
                                            : 'border-gray-200 bg-white'
                                }`}
                            >
                                <label className={`flex min-w-0 flex-1 items-center gap-2 ${
                                    !isProposalTypeComplete ? 'cursor-not-allowed' : 'cursor-pointer'
                                }`}>
                                    <input
                                        type="checkbox"
                                        disabled={!isProposalTypeComplete}
                                        checked={isSelected}
                                        onChange={() => handleChangePrototypeType(option)}
                                        className="hidden"
                                    />

                                    <div className={`flex h-3.5 w-3.5 shrink-0 items-center justify-center rounded-full border transition-all duration-200 ${
                                        isSelected ? 'border-[#186cb2] bg-[#186cb2]' : 'border-gray-400 bg-white'
                                    } ${!isProposalTypeComplete ? 'cursor-not-allowed' : ''}`}>
                                        {isSelected && <Checked />}
                                    </div>

                                    <span className={`min-w-0 flex-1 whitespace-normal break-words text-xs leading-5 ${
                                        isSelected ? 'font-medium text-[#186cb2]' : 'text-gray-700'
                                    }`}>
                                        {option.name}
                                    </span>
                                </label>

                                {/* {isSelected && ( */}
                                    <button
                                        type="button"
                                        disabled={!isProposalTypeComplete || isLoadingViewPrototypeTemplate}
                                        onClick={() => handleViewPrototypeTemplate(option.id)}
                                        className="flex shrink-0 items-center gap-1.5 rounded-md border border-[#186cb2]/20 bg-white px-2.5 py-1.5 text-[10px] font-medium text-[#186cb2] transition hover:border-[#186cb2]/40 hover:bg-[#186cb2]/5 disabled:cursor-not-allowed disabled:opacity-40"
                                        title="View prototype"
                                    >
                                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" className="h-3.5 w-3.5">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="M2.5 12s3.5-6 9.5-6 9.5 6 9.5 6-3.5 6-9.5 6-9.5-6-9.5-6Z" />
                                            <circle cx="12" cy="12" r="2.5" />
                                        </svg>
                                        View Template
                                    </button>
                                {/* )} */}
                            </div>
                        );
                    })
                )}
            </div>
            {isLoadingViewPrototypeTemplate && (
                <div className='mt-0'><LoadingViewFile/></div>
            )}
        </div>
    );
}